import React, { useEffect, useState, useCallback } from "react"
import { StreamChat as StreamChatClient } from "stream-chat"
import {
  Chat,
  Channel,
  ChannelList,
  ChannelHeader,
  MessageList,
  MessageInput,
  Thread,
  Window,
} from "stream-chat-react"

const MessengerInbox = ({ userId, userName, apiKey, token, filters = {}, sort = {}, options = {} }) => {
  const [client, setClient] = useState(null)
  const [error, setError] = useState(null)
  const [mobileView, setMobileView] = useState("list") // "list" or "channel"

  useEffect(() => {
    if (!apiKey || !token || !userId) {
      setError("Missing required configuration: apiKey, token, or userId")
      return
    }

    let chatClient = null
    let isActive = true

    const initChat = async () => {
      try {
        chatClient = StreamChatClient.getInstance(apiKey)
        await chatClient.connectUser({ id: userId, name: userName || userId }, token)
        if (!isActive) { await chatClient.disconnectUser(); return }
        setClient(chatClient)
      } catch (err) {
        console.error("MessengerInbox: Failed to initialize:", err)
        if (isActive) setError(`Failed to connect: ${err.message}`)
      }
    }

    initChat()
    return () => {
      isActive = false
      if (chatClient) chatClient.disconnectUser().catch(() => {})
    }
  }, [apiKey, token, userId, userName])

  const handleChannelSelect = useCallback(() => {
    setMobileView("channel")
  }, [])

  const handleBack = useCallback(() => {
    setMobileView("list")
  }, [])

  if (error) {
    return (
      <div className="cf-messenger-error">
        <div className="cf-messenger-error__icon">!</div>
        <h3>Messenger Connection Error</h3>
        <p>{error}</p>
      </div>
    )
  }

  if (!client) {
    return (
      <div className="cf-messenger-loading">
        <div className="cf-messenger-loading__spinner" />
        <p>Connecting to messenger...</p>
      </div>
    )
  }

  const channelFilters = {
    type: "messaging",
    members: { $in: [userId] },
    ...filters,
  }

  const channelSort = sort.last_message_at !== undefined ? sort : { last_message_at: -1, ...sort }

  const channelOptions = {
    state: true,
    watch: true,
    presence: true,
    limit: 20,
    ...options,
  }

  return (
    <div className={`cf-messenger-inbox cf-messenger-inbox--${mobileView}`}>
      <Chat client={client} theme="str-chat__theme-dark">
        <div className="cf-messenger-inbox__sidebar">
          <ChannelList
            filters={channelFilters}
            sort={channelSort}
            options={channelOptions}
            onSelect={handleChannelSelect}
            showChannelSearch
          />
        </div>
        <div className="cf-messenger-inbox__main">
          {mobileView === "channel" && (
            <button className="cf-messenger-inbox__back" onClick={handleBack}>
              &larr; Back
            </button>
          )}
          <Channel>
            <Window>
              <ChannelHeader />
              <MessageList />
              <MessageInput />
            </Window>
            <Thread />
          </Channel>
        </div>
      </Chat>
    </div>
  )
}

export default MessengerInbox
